<template>

  <v-container
    v-if="group && groups"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title>Grup</v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>

          <v-col cols="12">
            <v-select v-model="group.parent_id" label="Părinte" :items="groups" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <v-text-field v-model="group.name" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="group.description" label="Descriere" class="ma-1" outlined dense hide-details/>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="group.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import group_repository from '@/repositories/group-repository'

  export default {

    components: {

    },

    data: () => ({
      group: null,
      groups: [],

      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    created() {
      group_repository.getHotelGroup(this.$route.params.group).then(r => this.group = r);
      group_repository.getHotelGroups(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true}).then(r => this.groups = r);
    },

    methods: {

      async save() {
        try {
          this.saving = true;
          this.group = await group_repository.saveHotelGroup(this.group);
          await this.$store.dispatch('alert/success', 'Grupul a fost salvată.');

          if (this.$route.params.group === 'create')
            await this.$router.push(`/hotel-groups/${this.group.id}`);

          this.group = await group_repository.getHotelGroup(this.group.id);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await group_repository.destroyHotelGroup(this.group);
          await this.$router.push(`/hotel-groups`);
          await this.$store.dispatch('alert/success', 'Grupul a fost șters.');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      },

    }

  }
</script>

